import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/billing/')({
  component: () => {
    const { workspaceId } = Route.useParams()
    return <Navigate to="/workspaces/$workspaceId/billing/summary" params={{ workspaceId }} replace />
  },
})
